import { createFileRoute } from '@tanstack/react-router';
import { getGetCompaniesQueryOptions } from '@area-restrita/api-client/endpoints/companies/companies.gen';
import { getGetCompanyDepartmentsQueryOptions } from '@area-restrita/api-client/endpoints/departments/departments.gen';

import CompanyDocumentPermission from '@/modules/documents/pages/company-document-permission';

import { Route as CompanyDocumentPageRoute } from './route';

export const Route = createFileRoute(
  '/_authenticated/_system/documents/$companyDocumentPublicId/_documentOverview/permissions',
)({
  head: () => ({
    meta: [{ title: 'Permissões do Documento da Empresa' }],
  }),
  loader: async ({ context: { queryClient } }) => {
    const companies = await queryClient.ensureQueryData(
      getGetCompaniesQueryOptions({
        page: 1,
        limit: 1000,
      }),
    );

    const departments = await queryClient.ensureQueryData(
      getGetCompanyDepartmentsQueryOptions({
        page: 1,
        limit: 1000,
      }),
    );

    return {
      companies: companies.data,
      departments: departments.data,
    };
  },
  component: function CompanyDocumentPermissionsPage() {
    const { companies, departments } = Route.useLoaderData();
    const companyDocument = CompanyDocumentPageRoute.useLoaderData();

    return (
      <CompanyDocumentPermission
        companies={companies}
        departments={departments}
        companyDocument={companyDocument}
      />
    );
  },
});
